import ConfigAuth from '../configs/ConfigAuth';
import Cookies from "js-cookie";

const userAuthorization = (data) => ConfigAuth.post('/auth/login', data);

const refreshToken = () => ConfigAuth.request({
  url: '/auth/refresh',
  method: 'POST',
  headers: {
    Authorization: Cookies.get('adminToken'),
  }
});

// Google Sign-In goes through cms-api's own /api/auth/google endpoint, which
// proxies to google-integration-sv for id_token verification and then issues
// an adminToken via auth.internal.client.
const googleLogin = (idToken) => ConfigAuth.post('/api/auth/google', { id_token: idToken });


export default {
  userAuthorization,
  refreshToken,
  googleLogin,
};
